import React from "react";
import { sortObjectsByAlphabet } from "../../utils";
import SelectV2 from "../../view/SelectV2";

function DomainField({ domains, value, onChange, disabled }) {

    const handleChange = (id) => {
        if (String(id) === "-1" || id === "") {
            onChange(undefined);
            return;
        }

        const domain = domains.find((domain) => String(domain.id) === String(id));
        onChange(domain);
    };

    const domainOptions = [
        { value: "-1", label: "Choose" },
        ...sortObjectsByAlphabet(domains || [], "name").map((domain) => ({
            value: String(domain.id),
            label: domain.name
        }))
    ];

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="domain">Domain</label>
                <SelectV2
                    inputId="domain"
                    value={String(value ?? "-1")}
                    onChange={handleChange}
                    options={domainOptions}
                    isDisabled={disabled}
                    noOptionsMessage={() => "No domains found"}
                />
            </div>
        </div>
    );
}

export default DomainField;
